//import { id } from 'date-fns/locale';
import { makeAutoObservable, runInAction } from 'mobx';
//import { toast } from 'react-toastify';
import agent from '../api/agent';
import { createCATModulos, createCATModulosFormValues } from '../models/CATModulos';
//import { store } from './store';

export default class CATModulosStore {
    CATModulosRegistry = new Map<any, createCATModulos>();
    
    selectedCATModulos: createCATModulos | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    codigoCursoRespuesta: string = ""

    constructor() {
        makeAutoObservable(this)
    }

    // private setCATModulos = (data: createCATModulos) => {
    //     this.CATModulosRegistry.set(data.cuenta, data);
    // }

    // private getCATModulos = (idCliente: any) => {
    //     return this.CATModulosRegistry.get(idCliente);
    // }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    createCATModulosFun = async (createModulos: createCATModulosFormValues) => {
        try {
            await agent.CATModulos.create(createModulos)
            runInAction(() => {
                this.selectedCATModulos = createModulos;
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }
}